import React from 'react';

const LoadingError = ({isSymbol, message}) => {
  isSymbol = isSymbol || false;
  message = message || 'No Error Message'
  
  return(
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <p className="text-danger" style={{fontSize: '24px'}}>
        Loading failed!
        <span><i className="fa fa-warning" title={message} /></span>
      </p>
    </div>
  )
}

export default LoadingError;


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/LoadingError.jsx